$( window ).on("load", function() {
    if ($("#search-bar-right").length) {
        let elem = $('#home-navigation-bar').first();
        parentWidth = elem.width();
        let itemTotalWidth = 0;
        elem.children().each(function() {
            itemTotalWidth+=$(this).width();
        });
        let searchBarSpace = (parentWidth - itemTotalWidth)/2;
        if (searchBarSpace >= 300) {
            $("#search-bar-right").first().addClass('search-bar-inline');
            $('.logo-area__left').first().find('.wishlist-icon').first().addClass('search-bar-inline');
        } 
        else {
            $("#search-bar-right").first().removeClass('search-bar-inline');
            $(".ipad-only").each(function () {
                $(this).addClass('search-bar-inline');
            })
        }
        $( window ).on("resize",function() {
            parentWidth = elem.width();
            searchBarSpace = (parentWidth - itemTotalWidth)/2;
            searchBarSpace >= 300 ? ($("#search-bar-right").first().addClass('search-bar-inline')) : ($("#search-bar-right").first().removeClass('search-bar-inline'));
            searchBarSpace >= 300 ? ($('.logo-area__left').first().find('.wishlist-icon').first().addClass('search-bar-inline')) : ($('.logo-area__left').first().find('.wishlist-icon').first().removeClass('search-bar-inline'));
            searchBarSpace >= 300 ? ($(".ipad-only").each(function() {
                $(this).first().removeClass('search-bar-inline');
            })) : ($(".ipad-only").each(function() {
                $(this).first().addClass('search-bar-inline');
            }));
        })
    }
    
});

